import React, { useEffect, useRef } from "react";
import { useService } from "@xstate/react";
import { Box, Flex, Spinner, Tooltip } from "@chakra-ui/react";
import { service } from "@uidaholib/shared/machines/map/map.machine";
import HelperButton from "./help-button";
import { Observer } from "mobx-react-lite";
import { helperInfo } from "@uidaholib/shared/models/ui/ui";
import { MapWidgets } from "./map-widgets";

export const WebMapView = ({ mapId, appName }) => {
  const [state, send] = useService(service);

  const widgetId = "map-widget-ref";
  const helpButtonId = "map-helper-button";

  if (state.matches("loaded")) {
    state.context.view.when(() => {
      state.context.view.ui.add(`${helpButtonId}`, "top-right");
      state.context.view.ui.add(`${widgetId}`, "top-right");
    });
  }

  return (
    <>
      <Observer>
        {() => (
          <Box>
            <MapWidgets id={widgetId} />
            <HelperButton id={helpButtonId} show={state.matches("loaded")} />
            <Flex
              justifyContent="center"
              alignItems="center"
              zIndex={10}
              mt={24}
              ml={20}
              h="100%"
              w="100%"
            >
              <Tooltip
                zIndex={70}
                label="Zoom to an area of interest and point-and-click to download data"
                isOpen={helperInfo.isOpen}
              >
                <Box></Box>
              </Tooltip>
            </Flex>
            <Box
              pos="fixed"
              top="0"
              right="0"
              bottom="0"
              left="0"
              w="100%"
              h="100%"
              id={mapId}
              // ref={mapRef}
            ></Box>
          </Box>
        )}
      </Observer>

      {state.value !== "loaded" && (
        <Flex pos="absolute" left="50%" ml={-6} mt={12} color="blue.500">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
            label="loading..."
          />
        </Flex>
      )}
    </>
  );
};
